const urlAppendParam = (paramName, paramValue) => {
  const params = new URLSearchParams(window.location.search);
  params.set(paramName, paramValue);
  return `?${params.toString()}`;
};

module.exports = { urlAppendParam };
